export const enum TypesCell {
  FULL = 'full',
  REDUCTION = 'speed_reduction',
  PLANNED_STOP = 'planned_stop',
  UNPLANNED_STOP = 'unplanned_stop',
  WITHOUT_PRODUCTION = 'without_production',
  TECHNICAL_STOP = 'technical_stop',
}
